import type { QuestionStage, QuestionView } from '@dataroom/shared';

/** The buyer Q&A queue stages (ADR-0039), in the order the Q&A page lists them. */
export const QA_STAGES: QuestionStage[] = ['new', 'with_seller', 'draft_ready', 'answered', 'closed'];

export const QA_STAGE_LABELS: Record<QuestionStage, string> = {
  new: 'Needs answer',
  with_seller: 'With seller',
  draft_ready: 'Draft ready to release',
  answered: 'Answered',
  closed: 'Closed',
};

/** Questions waiting on the intermediary — new, or a seller draft to release
 * (the room nav's Q&A badge). */
export function questionsNeedingAction(questions: readonly QuestionView[] | undefined): number {
  return (questions ?? []).filter((q) => q.stage === 'new' || q.stage === 'draft_ready').length;
}
